// extracted by mini-css-extract-plugin
export default {"cls1":"LanguageSwitcherModal-cls1___bba6490fa9b89c9f9bd","cls2":"LanguageSwitcherModal-cls2__cf37a8e4cef8050a74bb LanguageSwitcherModal-cls1___bba6490fa9b89c9f9bd"};